"use strict";

exports.__esModule = true;
exports.validFbPixelId = exports.validGTMTrackingId = exports.validGATrackingId = void 0;

var validGATrackingId = function validGATrackingId(options) {
  return options.googleAnalytics && options.googleAnalytics.trackingId && options.googleAnalytics.trackingId.trim() !== "";
};

exports.validGATrackingId = validGATrackingId;

var validGTMTrackingId = function validGTMTrackingId(options) {
  return options.googleTagManager && options.googleTagManager.trackingId && options.googleTagManager.trackingId.trim() !== "";
};

exports.validGTMTrackingId = validGTMTrackingId;

var validFbPixelId = function validFbPixelId(options) {
  return options.facebookPixel && options.facebookPixel.pixelId && options.facebookPixel.pixelId.trim() !== "";
};

exports.validFbPixelId = validFbPixelId;